<template>
    <div class="downgrade-premium-features text-center mt-8 mb-10 md:mb-12">
        <h3
            class="font-normal text-black text-3xl leading-10 mb-5 lg:text-4xl"
        >You’ll lose these premium features</h3>

        <ul class="-mx-8 md:-mx-3 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
            <li v-for="(feature, i) in features" :key="i" class="px-8 my-2 md:px-3">
                <DowngradeFeaturesListItem :feature="feature" />
            </li>
        </ul>
    </div>
</template>

<script>
import DowngradeFeaturesListItem from "./DowngradeFeaturesListItem";

export default {
    components: {
        DowngradeFeaturesListItem
    },

    data: () => ({
        features: [
            {
                icon: require("!html-loader!@@/assets/site/svg/paper-scroll.svg"),
                title: "Asset Licenses",
                text:
                    "You’ll no longer be able to use your \
                downloaded assets for new projects."
            },
            {
                icon: require("!html-loader!@@/assets/site/svg/marketplace-big.svg"),
                title: "Unlimited Assets",
                text:
                    "You’ll only be able to download free \
                assets after your downgrade."
            },
            {
                icon: require("!html-loader!@@/assets/site/svg/plugins-big.svg"),
                title: "Premium Plugins",
                text: "Use of premium plugins will be watermarked."
            },
        ]
    })
};
</script>